const parseUrlQuery = query => {
  const parts = query.indexOf('?') > -1 ? query.split('?')[1] : query;
  const params = new URLSearchParams(parts);
  return Array.from(params.keys()).reduce(
    (acc, key) => ({
      ...acc,
      [key]: params.get(key),
    }),
    {},
  );
};

export default parseUrlQuery;
